<template>
  <a-card :bordered="false" class="smart-water-page">
    <div class="table-page-search-wrapper search-panel">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="12">
            <a-form-item label="版本名称">
              <a-input v-model="query.versionName" placeholder="请输入版本名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <span class="table-page-search-submitButtons action-buttons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()" v-action:add>新增</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <a-table
      class="smart-water-table"
      rowKey="id"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :row-selection="{ selectedRowKeys: selectedRows, onChange: onSelectChange }"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <template slot="updateDescription" slot-scope="text, record">
        <div v-if="text" class="desc-cell">
          <div class="html-preview" :title="getPlainText(text)">
            {{ getPlainText(text) }}
          </div>
          <a-button type="link" size="small" class="detail-link-btn" @click="openDescriptionDetail(record)">查看详情</a-button>
        </div>
        <span v-else>-</span>
      </template>
      <template slot="downloadUrl" slot-scope="text">
        <div v-if="text" class="url-preview" :title="text">
          <a :href="text" target="_blank" class="url-link">{{ text }}</a>
        </div>
        <span v-else>-</span>
      </template>
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)" v-action:edit>编辑</a>
      </span>
    </a-table>

    <a-modal
      title="智慧水务APP版本"
      style="top: 20px"
      :width="800"
      v-model="addOrUpdateVisible"
      :confirmLoading="submitLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form class="smart-water-form" :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="版本名称">
          <a-input
            placeholder="请输入版本名称，如 V1.0.9"
            v-decorator="['versionName', { rules: [{ required: true, message: '请输入版本名称' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="APP文件">
          <a-upload
            name="file"
            :before-upload="beforeUpload"
            :file-list="fileList"
            :remove="handleRemove"
            accept=".apk"
            :show-upload-list="true"
            :multiple="false"
          >
            <a-button>
              <a-icon type="upload" /> 选择APK文件
            </a-button>
          </a-upload>
          <div class="upload-tip">新增时必须上传，编辑时不上传则沿用当前文件</div>
          <div v-if="currentDownloadUrl" class="upload-tip">
            当前下载地址：<a :href="currentDownloadUrl" target="_blank">{{ currentDownloadUrl }}</a>
          </div>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="更新说明">
          <QuillEditor
            :value="updateDescriptionHtml"
            placeholder="请输入更新说明"
            @change="handleUpdateDescriptionChange"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-textarea
            placeholder="请输入备注（最多1000字）"
            v-decorator="['remarks']"
            :auto-size="{ minRows: 4 }"
          />
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      :title="`更新说明详情${detailVersionName ? ` - ${detailVersionName}` : ''}`"
      :width="760"
      v-model="descriptionVisible"
      :footer="null"
      @cancel="handleDescriptionCancel"
    >
      <div v-if="descriptionHtml" class="description-detail-content" v-html="descriptionHtml"></div>
      <a-empty v-else description="暂无更新说明" />
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import QuillEditor from '@/components/Editor/QuillEditor'

const columns = [
  {
    title: '版本名称',
    dataIndex: 'versionName',
    width: 140
  },
  {
    title: '更新说明',
    dataIndex: 'updateDescription',
    width: 220,
    scopedSlots: { customRender: 'updateDescription' }
  },
  {
    title: '下载地址',
    dataIndex: 'downloadUrl',
    width: 300,
    scopedSlots: { customRender: 'downloadUrl' }
  },
  {
    title: '备注',
    dataIndex: 'remarks',
    width: 140
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    width: 180
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    width: 120,
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  name: 'SmartWaterApp',
  mixins: [mixinViewModule],
  components: {
    QuillEditor
  },
  data () {
    return {
      columns,
      currentId: '',
      queryUrl: '/water-app/app_versions/page',
      queryOneUrl: '/water-app/app_versions',
      addOrUpdateUrl: '/water-app/app_versions',
      deleteUrl: '/water-app/app_versions',
      query: {
        versionName: ''
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'smartWaterAppForm' }),
      selectedRows: [],
      fileList: [],
      uploadFile: null,
      updateDescriptionHtml: '',
      currentDownloadUrl: '',
      submitLoading: false,
      descriptionVisible: false,
      descriptionHtml: '',
      detailVersionName: ''
    }
  },
  methods: {
    queryList () {
      const params = {
        ...this.query,
        page: this.pagination.current,
        limit: this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http.get(this.queryUrl, { params }).then(({ data }) => {
        this.dataListLoading = false
        this.list = data.list || data.records || []
        this.pagination.total = data.total ? parseInt(data.total) : 0
        this.selectedRows = []
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    pageChange (pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.queryList()
    },
    resetList () {
      this.query = {
        versionName: ''
      }
      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
    },
    addOrUpdateHandle (id) {
      this.currentId = id || ''
      this.addOrUpdateForm.resetFields()
      this.fileList = []
      this.uploadFile = null
      this.updateDescriptionHtml = ''
      this.currentDownloadUrl = ''
      this.addOrUpdateVisible = true
      if (id) {
        this.$http.get(`${this.queryOneUrl}/${id}`).then(({ data }) => {
          this.currentDownloadUrl = data.downloadUrl || ''
          this.updateDescriptionHtml = data.updateDescription || ''
          this.$nextTick(() => {
            this.addOrUpdateForm.setFieldsValue({
              versionName: data.versionName,
              remarks: data.remarks
            })
          })
        }).catch(() => {})
      }
    },
    handleUpdateDescriptionChange (html) {
      this.updateDescriptionHtml = html || ''
    },
    getPlainText (html) {
      if (!html) return ''
      return html
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
    },
    openDescriptionDetail (record) {
      this.descriptionHtml = record.updateDescription || ''
      this.detailVersionName = record.versionName || ''
      this.descriptionVisible = true
    },
    handleDescriptionCancel () {
      this.descriptionVisible = false
      this.descriptionHtml = ''
      this.detailVersionName = ''
    },
    beforeUpload (file) {
      const isAPK = file.type === 'application/vnd.android.package-archive' || file.name.toLowerCase().endsWith('.apk')
      if (!isAPK) {
        this.$message.error('只能上传APK文件')
        return false
      }
      const isLt100M = file.size / 1024 / 1024 < 100
      if (!isLt100M) {
        this.$message.error('文件大小不能超过100MB')
        return false
      }
      this.uploadFile = file
      this.fileList = [{
        uid: file.uid,
        name: file.name,
        status: 'done'
      }]
      return false
    },
    handleRemove () {
      this.fileList = []
      this.uploadFile = null
    },
    uploadAppFile () {
      const formData = new FormData()
      formData.append('file', this.uploadFile)
      return this.$http.post('/manager/file/resources/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        if ((res.code === 0 || res.code === 200) && res.data && res.data.url) {
          return res.data.url
        }
        return Promise.reject(new Error(res.message || '文件上传失败'))
      })
    },
    handleOk (e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (err) return
        if (!this.updateDescriptionHtml || this.updateDescriptionHtml === '<p><br></p>') {
          return this.$message.warn('请输入更新说明')
        }
        if (!this.uploadFile && !this.currentId) {
          return this.$message.warn('请先上传APP文件')
        }
        this.submitLoading = true
        const submit = (downloadUrl) => {
          const submitValues = {
            ...values,
            updateDescription: this.updateDescriptionHtml
          }
          const payload = this.currentId
            ? { id: this.currentId, downloadUrl: downloadUrl || this.currentDownloadUrl, ...submitValues }
            : { downloadUrl, ...submitValues }
          this.$http[this.currentId ? 'put' : 'post'](this.addOrUpdateUrl, payload).then((res) => {
            this.submitLoading = false
            if (res.code === 0 || res.code === 200) {
              this.$message.success(res.message || '操作成功')
              this.addOrUpdateVisible = false
              this.fileList = []
              this.uploadFile = null
              this.updateDescriptionHtml = ''
              this.currentDownloadUrl = ''
              this.queryList()
            } else {
              this.$message.error(res.message || '操作失败')
            }
          }).catch(() => {
            this.submitLoading = false
          })
        }
        if (this.uploadFile) {
          this.uploadAppFile().then((url) => {
            submit(url)
          }).catch((error) => {
            this.submitLoading = false
            this.$message.error(error.message || '文件上传失败')
          })
        } else {
          submit('')
        }
      })
    },
    handleCancel () {
      this.addOrUpdateForm.resetFields()
      this.fileList = []
      this.uploadFile = null
      this.updateDescriptionHtml = ''
      this.currentDownloadUrl = ''
      this.submitLoading = false
    },
    onSelectChange (selectedRowKeys) {
      this.selectedRows = selectedRowKeys
    },
    deleteSelectRow () {
      if (!this.selectedRows.length) {
        return this.$message.warn('请选择要删除的数据')
      }
      const _this = this
      this.$confirm({
        title: '删除提醒',
        content: `您确认要删除选择的${this.selectedRows.length}条数据吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          _this.$http.delete(_this.deleteUrl, { data: _this.selectedRows }).then((res) => {
            if (res.code === 0) {
              _this.$message.success(res.message || `共删除${_this.selectedRows.length}条数据`)
              _this.selectedRows = []
              _this.queryList()
            }
          }).catch(() => {})
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.smart-water-page .ant-card-body {
  padding: 20px 24px;
}

/deep/.table-striped {
  background-color: #f8fbff;
}

.smart-water-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

.search-panel {
  padding: 12px 16px 0;
  margin-bottom: 12px;
  background: #fafcff;
  border: 1px solid #f0f4fa;
  border-radius: 6px;
}

.action-buttons .ant-btn {
  border-radius: 4px;
}

.smart-water-table /deep/ .ant-table-thead > tr > th {
  background: #fafafa;
  color: #4a5568;
  font-weight: 600;
}

.smart-water-table /deep/ .ant-table-tbody > tr > td {
  padding-top: 10px;
  padding-bottom: 10px;
  color: #2d3748;
}

.upload-tip {
  color: rgba(0, 0, 0, 0.45);
  line-height: 20px;
}

.html-preview {
  max-width: 220px;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 18px;
  min-height: 36px;
  background: #f8fafc;
  border: 1px solid #edf2f7;
  border-radius: 4px;
  padding: 6px 8px;
}

.url-preview {
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.url-preview a {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.url-link {
  color: #1677ff;
}

.url-link:hover {
  color: #4096ff;
  text-decoration: underline;
}

.html-preview,
.url-preview {
  word-break: break-word;
}

.desc-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.detail-link-btn {
  padding-left: 0;
  height: 20px;
  margin-top: 2px;
  font-size: 12px;
}

.description-detail-content {
  max-height: 480px;
  overflow-y: auto;
  padding: 8px 12px;
  line-height: 1.75;
  word-break: break-word;
  background: #fcfcfc;
  border-radius: 6px;
}

.smart-water-form {
  /deep/ .ant-editor-quill .ql-container.ql-snow {
    min-height: 220px;
  }
}
</style>
